import { render, staticRenderFns } from "./reportparsing.vue?vue&type=template&id=c1c21058&scoped=true&"
import script from "./reportparsing.vue?vue&type=script&lang=js&"
export * from "./reportparsing.vue?vue&type=script&lang=js&"
import style0 from "./reportparsing.vue?vue&type=style&index=0&id=c1c21058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c21058",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1c21058')) {
      api.createRecord('c1c21058', component.options)
    } else {
      api.reload('c1c21058', component.options)
    }
    module.hot.accept("./reportparsing.vue?vue&type=template&id=c1c21058&scoped=true&", function () {
      api.rerender('c1c21058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/physical/reportparsing.vue"
export default component.exports